import styled from '@emotion/styled';

export const PostList = styled.ul`
	display: flex;
	flex-direction: column;
	width: 100%;
`;
export const PostListItem = styled.li`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	padding: 1.6rem 0;
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	letter-spacing: -0.6px;
	line-height: 100%;
	border-bottom: 1px solid #e9ecef;
	cursor: pointer;
	.title {
		color: #212529;
		width: 100%;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		font-size: ${(props) => props.theme.fontSize.sizeMd};
	}
	.sub_title {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 0.8rem;
		color: #868e96;
		font-size: ${(props) => props.theme.fontSize.sizeSm};
	}
`;
